import React, { useState } from 'react';
import { Box, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import ApprovalQueue from './ApprovalQueue';
import Approvers from './Approvers';

// Slot Capacity Approval — new Settings tab. Two sub-views (the reviewed prototype has no
// separate "My Requests" view — a requester's own pending FILE request already can't be
// self-superseded, server-side), same array-of-{label,content} + useState-index pattern the
// rest of this app's tab bars already use (Settings.js, HubSlotDetail.jsx).
function CapacityApprovals({ user, permissions }) {
    const [activeTab, setActiveTab] = useState(0);
    const isCapacityApproverDecider = !!user?.config?.isCapacityApproverDecider;
    const slotCapacityMultiOrgUploadEnabled = !!user?.config?.slotCapacityMultiOrgUploadEnabled;

    const _TAB = [
        {
            label: 'Approval Queue',
            content: (
                <ApprovalQueue
                    permissions={permissions}
                    isCapacityApproverDecider={isCapacityApproverDecider}
                />
            ),
        },
        {
            label: 'Approvers',
            content: (
                <Approvers
                    permissions={permissions}
                    isCapacityApproverDecider={isCapacityApproverDecider}
                    slotCapacityMultiOrgUploadEnabled={slotCapacityMultiOrgUploadEnabled}
                />
            ),
        },
    ];

    return (
        <Box>
            <Box style={{ display: 'flex', marginBottom: 16 }}>
                {_TAB.map((tab, index) => (
                    <Button
                        key={index}
                        className={`tab-button ${
                            index === activeTab ? 'active' : ''
                        }`}
                        onClick={() => setActiveTab(index)}
                        disableElevation
                        style={{ marginRight: 8, fontWeight: 'bold' }}
                    >
                        {tab.label}
                    </Button>
                ))}
            </Box>
            {_TAB[activeTab].content}
        </Box>
    );
}

const mapStateToProps = (state) => ({
    user: state?.user,
});

export default connect(mapStateToProps)(CapacityApprovals);
